<app-scheduler-create-ticket-view
  [props]="createticketViewProps"
  [tickets]="tickets"
></app-scheduler-create-ticket-view>
